import { useMemo } from "react";
import { ThemeProvider } from "styled-components";
import baseTheme from "../styles/theme";
import { useAccent } from "../context/AccentContext";
import { usePageTheme } from "../context/PageThemeContext";

const LIGHT_OVERRIDES = {
  light: true,
  bg: "#ffffff",
  cardBg: "rgba(0, 0, 0, 0.02)",
  cardBorder: "rgba(0, 0, 0, 0.08)",
  textPrimary: "#111111",
  textSecondary: "rgba(0, 0, 0, 0.45)",
  buttonBg: "#111111",
  dropdownBg: "#ffffff",
};

export default function AccentThemeProvider({ children }) {
  const { active } = useAccent();
  const { light } = usePageTheme();

  const theme = useMemo(
    () => ({
      ...baseTheme,
      accent: active.hex,
      accentRgb: active.rgb,
      accentDark: active.dark,
      ...(light ? LIGHT_OVERRIDES : {}),
    }),
    [active, light],
  );

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
